<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-body">
            <div class="image-modal">
              <div class="image-modal-content" (click)="$event.stopPropagation()">
                <div class="image-modal-content" (click)="$event.stopPropagation()">
                    <span class="close-button" data-bs-dismiss="modal" (click)="closeModal()">x</span>
                    <div #rendererContainer class="viewer-container"></div>
                </div>
            </div>
        </div>
    </div>
</div>
